<template>
  <v-container>
    <!-- <v-card> -->
    <!-- seleccion de estados y colores-->
    <div>
      <h2>Filtro entre fechas</h2>
      {{ selectedItem.customized }}
    </div>
    <v-row>
      <v-col>
        <v-text-field
          v-model="selectedItem.name"
          label="Nombre del buscador"
          persistent-hint
          outlined
        >
        </v-text-field>

        <v-text-field
          v-model="selectedItem.customized.rutaApi"
          label="Api de consulta"
          persistent-hint
          outlined
        >
        </v-text-field>

        <v-text-field
          v-model="selectedItem.customized.fechaInicio"
          label="Parámetro de fecha inicio"
          persistent-hint
          outlined
        >
        </v-text-field>

        <v-text-field
          v-model="selectedItem.customized.fechaFin"
          label="Parámetro de fecha fin"
          persistent-hint
          outlined
        >
        </v-text-field>
        <v-text-field
          v-model="selectedItem.customized.otros"
          label="Otros parámetros"
          persistent-hint
          outlined
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
// import moment from 'moment';
export default {
  data() {
    return {
      date1: null,
      time1: null,
      date2: null,
      time2: null,
    };
  },
  computed: {
    ...mapState(["selectedItem"]),
  },
};
</script>

<style scoped>
.color-square {
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.style-estado {
  display: flex;
  align-items: center;
  /* Centra verticalmente los elementos */
}

.estado-txt {
  margin-left: 10px;
  /* Ajusta el espacio entre el input de color y el checkbox */
}
</style>
